import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col w-full" }
const _hoisted_2 = ["disabled", "onClick"]
const _hoisted_3 = { class: "flex flex-row justify-between items-center w-full" }
const _hoisted_4 = { class: "text-gray-900 font-semibold text-lg mb-1" }
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = { class: "text-gray-700 font-medium border border-gray-200 bg-gray-50 px-3 px-1 rounded-xl text-sm mr-4" }
const _hoisted_7 = { class: "inline-flex items-center cursor-pointer mr-4" }
const _hoisted_8 = ["onUpdate:modelValue", "onChange", "checked"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "relative w-11 h-6 bg-gray-100 peer-focus:outline-none rounded-full peer dark:bg-gray-100 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600" }, null, -1)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "mx-auto flex items-center justify-center" }
const _hoisted_14 = { class: "mt-5 text-center" }
const _hoisted_15 = { class: "text-lg font-semibold mb-1" }
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = { class: "text-sm text-gray-600 mb-8" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = { class: "mt-6 flex justify-around items-center flex-row" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1)
const _hoisted_21 = { class: "fixed inset-0 z-10 w-screen overflow-y-auto" }
const _hoisted_22 = { class: "flex min-h-full items-end justify-center p-8 text-center sm:items-center" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M13 1L1 13M1 1L13 13",
    stroke: "#98A2B3",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "mx-auto flex items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
      fill: "#DCFAE6"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M34 33V31C34 29.1362 32.7252 27.5701 31 27.126M27.5 15.2908C28.9659 15.8841 30 17.3213 30 19C30 20.6787 28.9659 22.1159 27.5 22.7092M29 33C29 31.1362 29 30.2044 28.6955 29.4693C28.2895 28.4892 27.5108 27.7105 26.5307 27.3045C25.7956 27 24.8638 27 23 27H20C18.1362 27 17.2044 27 16.4693 27.3045C15.4892 27.7105 14.7105 28.4892 14.3045 29.4693C14 30.2044 14 31.1362 14 33M25.5 19C25.5 21.2091 23.7091 23 21.5 23C19.2909 23 17.5 21.2091 17.5 19C17.5 16.7909 19.2909 15 21.5 15C23.7091 15 25.5 16.7909 25.5 19Z",
      stroke: "#079455",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_26 = { class: "mt-5 text-center" }
const _hoisted_27 = { class: "text-center" }
const _hoisted_28 = { class: "text-sm text-[#475467] mb-8" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_30 = { class: "mt-6 flex justify-around items-center flex-row" }

import AdminSchoolDetails from "@/modules/main/components/AdminSchoolDetailsComponent.vue";
import { computed, reactive, ref } from "vue";
import { useSchoolStore } from "@/stores/schoolStore";
import { useLearnerStore } from "@/stores/learnerStore";
import groupBy from "lodash/groupBy";
import {
  Dialog,
  DialogPanel,
  DialogTitle,
  TransitionChild,
  TransitionRoot,
} from "@headlessui/vue";

// stores

export default /*#__PURE__*/_defineComponent({
  __name: 'GradesClassesDetailsComponent',
  setup(__props) {

const schoolStore = useSchoolStore();
const learnerStore = useLearnerStore();

const grades = Array.from({ length: 12 }, (_, i) => i + 1); // Grades 1 to 12
const currentOpenGrade = ref(null);
const selectedGrade = ref(null);
const showModal = ref(false);
const showRemoveModal = ref(false);
const checkboxChecked: { [key: string]: boolean } = reactive({});

// Confirm the selection in the modal
const confirmSelection = async (grade: any) => {
  checkboxChecked[grade] = true; // Keep the checkbox checked
  currentOpenGrade.value = grade; // Open the grade section
  showModal.value = false; // Close the modal
  //Add the Grade to the school
  const toggleSchoolGradeData = {
    toggleGrade: {
      action: 'enable',
      gradeLevel: grade
    }
  }
  await toggleSchoolGrade(toggleSchoolGradeData);
};

// Confirm the grade deactivate in the modal
const confirmRemoveSelection = async (grade: any) => {
  checkboxChecked[grade] = false; // Keep the checkbox checked
  if (currentOpenGrade.value === currentOpenGrade.value) {
    currentOpenGrade.value = null; // Close the grade section
  }
  showRemoveModal.value = false; // Close the modal
  //Remove the Grade from the school
  const toggleSchoolGradeData = {
    toggleGrade: {
      action: 'disable',
      gradeLevel: grade
    }
  }
  await toggleSchoolGrade(toggleSchoolGradeData);
};

// Toggle the selected grade
const toggleGrade = (grade: any) => {
  currentOpenGrade.value = currentOpenGrade.value === grade ? null : grade;
};

// Open the confirmation modal only when the checkbox is being checked
const handleCheckboxChange = (grade: any, event: any) => {
  selectedGrade.value = grade;
  if (event.target.checked) {
    showModal.value = true;
  } else {
    showRemoveModal.value = true;
  }
};

const getLearnersByGrade = (grade: any) => {
  return learnerStore.getSchoolLearners.filter((learner) =>
    learner.classes?.some((classGroup) => classGroup.gradeLevel === grade)
  );
};

const getClassesByGrade = (grade: any) => {
  return schoolStore.currentSchoolStructure?.classGroups.filter(
    (classGroup) => classGroup.gradeLevel === grade
  );
};

const schoolGrades = computed(() => {
  const schoolStructure = schoolStore.currentSchoolStructure;
  return schoolStructure?.gradeLevels || [];
});

// Cancel the selection and uncheck the checkbox
const cancelSelection = (grade: any) => {
  currentOpenGrade.value = null; // Close the grade section
  checkboxChecked[grade] = false; // Uncheck the checkbox if modal is cancelled
  showModal.value = false; // Close the modal
};

// Cancel the remove selection and uncheck the checkbox
const cancelRemoveSelection = (grade: any) => {
  checkboxChecked[grade] = true; // check the checkbox if modal is cancelled
  showRemoveModal.value = false; // Close the modal
};

const learnersByGrade = computed(() => {
  const grouped = groupBy(learnerStore.getSchoolLearners, "grade");
  return Object.keys(grouped).map((grade) => ({
    level: parseInt(grade, 10),
    count: grouped[grade].length,
  }));
});

const schoolId = computed(() => schoolStore.currentSchool?.id || schoolStore.currentSchool?._id);

const toggleSchoolGrade = async (toggleGradeAction: any) => {
  try {
    await schoolStore.updateSchoolDetails(
      schoolId.value,
      toggleGradeAction
    );
  } catch (error) {
    console.error(error);
  }
};


return (_ctx: any,_cache: any) => {
  const _component_rl_icon = _resolveComponent("rl-icon")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(grades), (grade) => {
          return (_openBlock(), _createElementBlock("div", {
            key: grade,
            class: "bg-white border border-blue-300 rounded-xl p-6 w-full mb-6"
          }, [
            _createElementVNode("button", {
              disabled: 
            !schoolGrades.value.includes(grade)
          ,
              onClick: ($event: any) => (toggleGrade(grade)),
              class: "w-full"
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.$t("admin_screens.grade")) + " " + _toDisplayString(grade), 1),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("p", null, _toDisplayString(learnersByGrade.value.find((item) => item.level === grade)?.count ? learnersByGrade.value.find((item) => item.level === grade)?.count : 0) + " " + _toDisplayString(_ctx.$t("admin_screens.students")), 1)
                  ]),
                  _createElementVNode("label", _hoisted_7, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      value: "",
                      class: "sr-only peer",
                      "onUpdate:modelValue": ($event: any) => ((checkboxChecked[grade]) = $event),
                      onChange: ($event: any) => (handleCheckboxChange(grade, $event)),
                      checked: schoolGrades.value.includes(grade)
                    }, null, 40, _hoisted_8), [
                      [_vModelCheckbox, checkboxChecked[grade]]
                    ]),
                    _hoisted_9
                  ]),
                  (currentOpenGrade.value == grade)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                        _createVNode(_component_rl_icon, {
                          icon: 'rl-arrow-up',
                          title: 'rl arrow up',
                          "aria-hidden": "true"
                        })
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_11, [
                        _createVNode(_component_rl_icon, {
                          icon: 'rl-arrow-down',
                          title: 'rl arrow down',
                          "aria-hidden": "true"
                        })
                      ]))
                ])
              ])
            ], 8, _hoisted_2),
            (currentOpenGrade.value == grade)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createVNode(AdminSchoolDetails, {
                    gradeLevel: grade,
                    learners: getLearnersByGrade(grade),
                    classes: getClassesByGrade(grade),
                    class: "mt-16",
                    hasClasses: getClassesByGrade(grade).length > 0
                  }, null, 8, ["gradeLevel", "learners", "classes", "hasClasses"])
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ]),
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-xl px-4 py-6 rounded-lg',
      open: showModal.value,
      onLocalModalOpen: _cache[2] || (_cache[2] = ($event: any) => (showModal.value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_rl_icon, {
              icon: 'rl-green-person',
              title: 'rl green person',
              "aria-hidden": "true"
            })
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("h3", _hoisted_15, _toDisplayString(_ctx.$t("admin_screens.modals.add_new_grade_header")) + "!", 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("p", _hoisted_17, [
              _createTextVNode(_toDisplayString(_ctx.$t("admin_screens.modals.are_you_sure")) + " [grade]", 1),
              _hoisted_18,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("admin_screens.modals.to_the_program")) + "? ", 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("button", {
            type: "button",
            class: "text-gray-700 border border-gray-300 text-sm font-semibold px-4 py-2.5 bg-white rounded-lg mr-3 items-center flex-wrap w-full",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (cancelSelection(selectedGrade.value)))
          }, _toDisplayString(_ctx.$t("admin_screens.modals.cancel")), 1),
          _createElementVNode("button", {
            type: "button",
            class: "text-white border border-blue-600 bg-blue-600 text-sm font-semibold px-4 py-2.5 rounded-lg items-center flex-wrap w-full",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (confirmSelection(selectedGrade.value)))
          }, _toDisplayString(_ctx.$t("admin_screens.modals.im_sure")), 1)
        ])
      ]),
      _: 1
    }, 8, ["open"]),
    (showRemoveModal.value)
      ? (_openBlock(), _createBlock(_unref(TransitionRoot), {
          key: 0,
          as: "template",
          show: true
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Dialog), {
              as: "div",
              class: "relative z-40"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(TransitionChild), {
                  as: "template",
                  enter: "ease-out duration-300",
                  "enter-from": "opacity-0",
                  "enter-to": "opacity-100",
                  leave: "ease-in duration-200",
                  "leave-from": "opacity-100",
                  "leave-to": "opacity-0"
                }, {
                  default: _withCtx(() => [
                    _hoisted_20
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_unref(TransitionChild), {
                      as: "template",
                      enter: "ease-out duration-300",
                      "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                      "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                      leave: "ease-in duration-200",
                      "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                      "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(DialogPanel), { class: "p-8 relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _createElementVNode("button", {
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (cancelRemoveSelection(selectedGrade.value))),
                                class: "absolute top-4 right-4"
                              }, _hoisted_24),
                              _hoisted_25,
                              _createElementVNode("div", _hoisted_26, [
                                _createVNode(_unref(DialogTitle), {
                                  as: "h3",
                                  class: "text-lg font-semibold text-[##101828] mb-1"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("admin_screens.modals.remove_grade_header")), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_27, [
                                _createElementVNode("p", _hoisted_28, [
                                  _createTextVNode(_toDisplayString(_ctx.$t("admin_screens.modals.are_you_sure_remove")) + " [grade]", 1),
                                  _hoisted_29,
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t("admin_screens.modals.from_the_program")) + "? ", 1)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_30, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "text-[#344054] border border-[#D0D5DD] text-sm font-semibold px-4 py-2.5 bg-white rounded-lg mr-3 items-center flex-wrap w-full",
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (cancelRemoveSelection(selectedGrade.value)))
                              }, _toDisplayString(_ctx.$t("admin_screens.modals.cancel")), 1),
                              _createElementVNode("button", {
                                type: "button",
                                class: "text-white border border-[#155EEF] bg-[#155EEF] text-sm font-semibold px-4 py-2.5 rounded-lg items-center flex-wrap w-full",
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (confirmRemoveSelection(selectedGrade.value)))
                              }, _toDisplayString(_ctx.$t("admin_screens.modals.im_sure")), 1)
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})